export type EntityNumberFormat = 'INDIAN' | 'INTERNATIONAL';

// Grouping style → Intl locale. INDIAN = lakh/crore (12,34,567); INTERNATIONAL = 1,234,567.
const LOCALE: Record<EntityNumberFormat, string> = {
  INDIAN: 'en-IN',
  INTERNATIONAL: 'en-US',
};

function toNumber(value: string | number | null | undefined): number | null {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(String(value).replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
}

export interface NumberFormatOpts {
  numberFormat?: EntityNumberFormat;
  decimalPlaces?: number;
}

// Plain number with entity grouping + fixed decimals. Invalid/empty -> '—'
// (em-dash, the app-wide table empty style — keep it so every screen matches).
export function formatNumber(
  value: string | number | null | undefined,
  { numberFormat = 'INDIAN', decimalPlaces = 2 }: NumberFormatOpts = {},
): string {
  const n = toNumber(value);
  if (n === null) return '—';
  return new Intl.NumberFormat(LOCALE[numberFormat], {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(n);
}

export interface CurrencyFormatOpts extends NumberFormatOpts {
  currencySymbol?: string;
}

// Money value: currency symbol prefix + grouped number. Invalid/empty -> '—'.
export function formatCurrency(
  value: string | number | null | undefined,
  { currencySymbol = '₹', ...rest }: CurrencyFormatOpts = {},
): string {
  const n = toNumber(value);
  if (n === null) return '—';
  return `${currencySymbol}${formatNumber(n, rest)}`;
}
